import {Component, input, Input} from '@angular/core';

/**
 * One cell in a dashboard's stats row (e.g. Total Sales / Avg Order Value, or the refund dashboard's
 * Cancelled & Declined / Refunds Issued / Refund Rate). Strictly presentational — parent owns the data, period
 * filtering, and stat-derivation logic.
 *
 * The optional {@link description} renders as small subtext under the value; it is
 * omitted entirely when the tile is unavailable. The optional {@link tooltipText} adds an info bubble next to the
 * label explaining what the stat measures, and {@link isCompact} shrinks the padding and value so more tiles fit in
 * one row.
 */
@Component({
    selector: 'app-stat-tile',
    templateUrl: './stat-tile.component.html',
    styleUrls: ['./stat-tile.component.scss'],
    standalone: false
})
export class StatTileComponent
{
    @Input() label!: string;
    readonly tooltipText = input<string>();
    @Input() value: string | number | null = null;
    @Input() unavailable = false;
    @Input() unavailableText = 'Data unavailable';
    @Input() description?: string;
    readonly isCompact = input(false);
}
